/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var $ = jQuery;

var post = {};

(function($) {

  var Sage = {
    'common': {
      init: function() {

        console.log("window.gwrf");
        console.log(window.gwrf);

        var tabClicked = false;
        var left = 0;

        Barba.Pjax.start();

        var size = new BrowserSize();

        size.getWindowSize();

        $(window).resize(function() {
          size.getWindowSize();
        });

        Barba.Dispatcher.on('linkClicked', function(element, event) {

          console.log("linked clicked ", element, event);

          if ($(element).closest('.tab-navigation').length > 0) {

            console.log("this is tab item");

            left = $(element).closest('ul').scrollLeft();

            console.log("------------------- scrollLeft " + left);

            tabClicked = true;

          } else if ($(element.parentNode).hasClass("tab-link")) {

            console.log("this is menu item tab link");

            tabClicked = true;

          } else {

            console.log("this is not tab item");

            tabClicked = false;
          }

        });

        Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;

        Barba.Pjax.preventCheck = function(evt, element) {

          if (!Barba.Pjax.originalPreventCheck(evt, element)) {
            return false;
          }

          console.log("e " + element);

          if (/.pdf/.test(element.href.toLowerCase())) {
            return false;
          }
          if (element.className === 'ab-item') {
            console.log("prevent click on admin item");
            return false;
          }
          if (element.className === 'ab-submenu') {
            console.log("prevent click on admin item");
            return false;
          }

          return true;
        };

        var cookie = new Cookie();

        var menu = new Menu();

        var tabMenu = new TabMenu();

        var FadeTransition = Barba.BaseTransition.extend({
          start: function() {
            Promise
              .all([this.newContainerLoading, this.fadeOut()])
              .then(this.fadeIn.bind(this));
          },

          fadeOut: function() {
            return $(this.oldContainer).animate({ opacity: 0 }).promise();
          },

          fadeIn: function() {

            var _this = this;
            var $el = $(this.newContainer);

            /* ------------ inizializza componenti -----------*/

            if ($('#facilites-map', this.newContainer).length) {
              var faclities = new Facilities();
            }

            if ($('#amenities-map', this.newContainer).length) {
              var amenitiesMap = new AmenitiesMap();
            }

            if ($('.contact-form', this.newContainer).length) {
              console.log("contact page");
              var contactMap = new ContactMap();
            }

            if ($('.gform_wrapper', this.newContainer).length) {
              console.log("has form!!!");
              console.log(" gform_post_render 1");
              $(document).trigger('gform_post_render', [1, 0]);
            }

            if ($('#home-videos', this.newContainer).length) {
              var videos = new Videos();
            }

            if ($('#header-carousel', this.newContainer).length) {
              var carousel = new HeaderCarousel();
            }

            if ($('#home-departments', this.newContainer).length) {
              var departments = new DepartmentsSwiper();
            }

            if ($(".page-links", this.newContainer).length) {
              var scroll = new ScrollLinks();
            }

            if ($(".master-gallery", this.newContainer).length) {
              console.log("----------- master gallery");
              var galleries = new Galleries();
            }

            if ($("#tabs", this.newContainer).length) {
              console.log("called tabs");
              var tabMenu = new TabMenu(this.newContainer);
            }

            var menu = new Menu();
            var cookie = new Cookie();

            /* ============================================
               STEP 1: Nascondi vecchio, mostra nuovo
               ============================================ */

            $(this.oldContainer).hide();

            $el.css({
              visibility: 'visible',
              opacity: 0
            });

            /* ============================================
               STEP 2: Doppio requestAnimationFrame per
               garantire il reflow completo
               ============================================ */

            requestAnimationFrame(function() {
              requestAnimationFrame(function() {

                if (tabClicked === true) {

                  console.log("scroll to tab");

                  var $tabNav = $(".tab-navigation", $el);
                  var target = 0;

                  if ($tabNav.length) {
                    var offsetTop = $tabNav.offset().top;

                    console.log("---------------------- offsetTop ", offsetTop);
                    console.log("---------------------- size.winW ", size);

                    if (size.winW > 1199) {
                      target = offsetTop;
                    } else {
                      console.log("----------------------  less than 1199");
                      target = offsetTop - 60;
                    }
                  }

                  TweenMax.to(window, 1, {scrollTo: {y: target}, ease: Power2.easeInOut});

                  var selector = $(".tab-navigation ul", $el);
                  console.log("---------------------- left " + left);
                  TweenMax.set(selector, {scrollTo: {x: left}});

                } else {

                  TweenMax.to(window, 0, {scrollTo: {y: 0}, ease: Power2.easeInOut});
                }

                /* ============================================
                   STEP 3: Fade in
                   ============================================ */

                $el.animate({ opacity: 1 }, 400, function() {

                  _this.done();

                  gtag('config', 'UA-117106856-1', {'page_path': location.pathname});

                  if ($(".post-gallery", _this.newContainer).length) {
                    console.log("----------- post gallery");
                    post.gallery = new Gallery();
                  }
                });

              });
            });
          }
        });

        Barba.Pjax.getTransition = function() {
          return FadeTransition;
        };

      },
      finalize: function() {
      }
    },

    'single_post': {
      init: function() {
        post.gallery = new Gallery();
      }
    },
    'single_casestudy': {
      init: function() {
        console.log("----------- single casestudy");
        var galleries = new Galleries();
      }
    },
    'home': {
      init: function() {

        console.log("home");

        var carousel = new HeaderCarousel();
        var videos = new Videos();
        var departments = new DepartmentsSwiper();
        var statistics = new Statistics();

      },
      finalize: function() {
      }
    },
    'about_us': {
      init: function() {
      }
    },
    'page_template_template_contact': {
      init: function() {
        console.log("contact page");
        if ($('.contact-form').length) {
          console.log("contact page");
          var contactMap = new ContactMap();
        }
      }
    },
    'page_template_template_previous_event': {
      init: function() {
      }
    },
    'page_template_template_current_event': {
      init: function() {
      }
    },
    'page_template_template_facilities': {
      init: function() {
        var faclities = new Facilities();
      }
    },
    'page_template_template_amenities': {
      init: function() {
        if ($('#amenities-map').length) {
          var amenitiesMap = new AmenitiesMap();
        }
        var scroll = new ScrollLinks();
      }
    }
  };

  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      UTIL.fire('common');

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      UTIL.fire('common', 'finalize');
    }
  };

  $(document).ready(UTIL.loadEvents);

})(jQuery);
